import {
  Button,
  DialogBody,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@crono-one/design-system';
import SkeletonBlock from 'components/SkeletonBlock';

interface MeetingUpsertFallbackProps {
  hasFailed: boolean;
  onClose: () => void;
}

export function MeetingUpsertFallback({
  hasFailed,
  onClose,
}: MeetingUpsertFallbackProps) {
  return (
    <div className="flex-1 min-h-0 flex flex-col gap-6">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          Edit meeting
        </DialogTitle>
      </DialogHeader>

      <DialogBody className="gap-4">
        {hasFailed ? (
          <p className="text-sm font-medium text-gray-700 py-6">
            This meeting could not be loaded.
          </p>
        ) : (
          <div
            role="status"
            aria-label="Loading the meeting"
            className="flex flex-col gap-4"
          >
            <div className="grid grid-cols-2 gap-8">
              <div className="flex flex-col gap-1">
                <SkeletonBlock className="h-4 w-16" />
                <SkeletonBlock className="h-8 w-full" />
              </div>
              <div className="flex flex-col gap-1">
                <SkeletonBlock className="h-4 w-16" />
                <SkeletonBlock className="h-8 w-full" />
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <SkeletonBlock className="h-4 w-16" />
              <SkeletonBlock className="h-8 w-full" />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-2">
                <SkeletonBlock className="h-4 w-16" />
                <SkeletonBlock className="h-4 w-16" />
              </div>
              <SkeletonBlock className="h-28 w-full" />
            </div>

            <div className="flex flex-col gap-1">
              <SkeletonBlock className="h-4 w-16" />
              <SkeletonBlock className="h-8 w-full" />
            </div>

            <div className="flex flex-col gap-1">
              <SkeletonBlock className="h-4 w-16" />
              <SkeletonBlock className="h-8 w-full" />
            </div>

            <div className="flex flex-col gap-1">
              <SkeletonBlock className="h-4 w-16" />
              <SkeletonBlock className="h-8 w-full" />
            </div>
          </div>
        )}
      </DialogBody>

      <DialogFooter>
        <Button
          variant="outline"
          size="lg"
          className="min-w-30"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogFooter>
    </div>
  );
}
